import React from "react"
import { Helmet } from "react-helmet"
import classes from './Menu.module.scss'
import linkHappy from '../../MenuHappyHour.pdf'
import linkSpecials from '../../MenuSpecials.pdf'
import linkEarly from '../../MenuEarly.pdf'
import imageHappy from '../../assets/images/menuHappy.png'
import imageSpecials from '../../assets/images/menuSpecials.png'
import imageEarly from '../../assets/images/menuEarlyBird.png'

const happyHour = () => {
  return (
    <div id="happyHour" className={[classes.MenuPage___XXX, classes.whiteBoxStyle___XXX, classes.MenuHappy].join(' ')}>
      <Helmet>
        <title>Happy Hour and Daily Specials at Mile Marker 158 Dockside</title>
        <meta name="description" content="We offer our amazing menu and waterfront view 7 days a week! Come see us at The Wharf in Orange Beach." />
      </Helmet>
      
      <div className={classes.hdRow}>
        <div className={[classes.hdWrap, classes.medDef].join(' ')}>
          <h1>
            Happy Hour <span className={classes.dot1}>·</span> <br className={classes.br1} /> 
            Early Bird <span className={classes.dot2}>·</span> <br className={classes.br2} /> 
            <span className={classes.and}>&amp;</span> Weekly Specials
          </h1>
          <div className={classes.mobOpts}>
            <p>Skip To:</p>
            <div className={[classes.flexGroup, classes.listGroup].join(' ')}>
              <a href="#HappyHour" className={classes.textLink} data-uk-scroll>Happy Hour</a>
              <a href="#EarlyBird" className={classes.textLink} data-uk-scroll>Early Bird Menu</a>
              <a href="#WeeklySpecials" className={classes.textLink} data-uk-scroll>Weekly Specials</a>
            </div>
          </div>
          <p className={classes.instr}>Select a menu image below to view a larger version.</p>
        </div>
      </div>
      
      <div className={[classes.fullRow, classes.menuSection].join(' ')}>
        <div className={[classes.flexGroup, classes.inside15, classes.justifyBetween].join(' ')}>
          <div id="HappyHour" className={[classes.item, classes.i1].join(' ')}>
            <a href={linkHappy} target="_blank" rel="noopener noreferrer">
              <img src={imageHappy} alt="Mile Marker Happy Hour Menu" />
            </a>
          </div>
          <div id="EarlyBird" className={[classes.item, classes.i3].join(' ')}>
            <a href={linkEarly} target="_blank" rel="noopener noreferrer">
              <img src={imageEarly} alt="Mile Marker Early Bird Specials" />
            </a>
          </div>
          <div id="WeeklySpecials" className={[classes.item, classes.i2].join(' ')}>
            <a href={linkSpecials} target="_blank" rel="noopener noreferrer">
              <img src={imageSpecials} alt="Mile Marker Daily Specials" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
export default happyHour